import { render, staticRenderFns } from "./MyProgress.vue?vue&type=template&id=c69a5270&"
import script from "./MyProgress.vue?vue&type=script&lang=js&"
export * from "./MyProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
